<template>
  <v-form
    ref="form"
    v-model="validForm"
    lazy-validation
  >
    <v-card
      max-width="700px"
      class="mx-auto"
      outlined
    >
      <v-card-title :class="$vuetify.breakpoint.mdAndDown ? 'pa-6' : 'pa-10'">
        <v-row class="justify-space-between align-center">
          <v-col>
            <h1 class="headline font-weight-medium">
              <span>{{ isEditing ? `Edit` : `New` }} {{ editedReaction.reactionType.charAt(0).toUpperCase() + editedReaction.reactionType.slice(1) }} Reaction</span>
            </h1>
          </v-col>
          <v-col class="flex-grow-0 pa-0">
            <v-btn
              @click="closeModal"
              text
              fab
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-container :class="$vuetify.breakpoint.mdAndDown ? 'pa-0' : ''">
          <v-container class="grey--text">
            <span v-if="editedReaction.createdAt" class="mr-6">
              <strong>Created:</strong> {{ formatTimestamp(editedReaction.createdAt) }}
            </span>
            <span v-if="editedReaction.updatedAt">
              <strong>Updated:</strong> {{ formatTimestamp(editedReaction.updatedAt) }}
            </span>
            <p v-if="editedReaction.author && user.isAdmin && isEditing" class="mt-2">
              <strong>Author:</strong> {{ editedReaction.author.displayName }} (<a :href="'mailto:' + editedReaction.author.email">{{ editedReaction.author.email }}</a>)
            </p>
          </v-container>

          <v-col cols="12">
            <ImageUpload
              @setImgFields="setImgFields"
              :editedItem="editedReaction"
              :imgUrl="editedReaction.imgUrl"
              label="Post Image"
            />

            <v-text-field
              v-model="editedReaction.key"
              :rules="[rules.required]"
              label="Reaction Key"
              prepend-icon="mdi-format-title"
              class="value"
              counter="15"
              maxlength="15"
              hint="This has to be unique, and it must be all lower case letters and hyphens only"
            />

            <v-row>
              <v-col>
                Start Date
                <v-date-picker
                  v-model="formattedStartDate"
                />
              </v-col>
              <v-col>
                End Date
                <v-date-picker
                  v-model="formattedEndDate"
                  :min="formattedStartDate"
                />
              </v-col>
            </v-row>
          </v-col>

          <br><br>

          <v-card-actions>
            <v-spacer />
            <v-btn
              v-if="isEditing"
              @click="clearChanges"
              text
            >
              Clear Changes
            </v-btn>
            <v-btn
              @click="closeModal"
              color="primary darken-1"
              text
            >
              Cancel
            </v-btn>
            <v-btn
              @click="publish"
              color="primary"
              depressed
            >
              {{ isEditing ? 'Update' : 'Save' }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import { mapState } from 'vuex';
import BaseForm from './BaseForm';
import { ImageUpload } from 'components';

export default {
  name: 'ReactionForm',

  components: {
    ImageUpload,
  },

  extends: BaseForm,

  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    editedReaction: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
    };
  },

  computed: {
    ...mapState(['user']),

    userCanEdit() {
      return !(!this.user.isAdmin && this.editedReaction.workflowState !== 'draft');
    },

    formattedStartDate: {
      get(){
        return this.formattedDate(this.editedReaction.startDate);
      },
      set(value){
        this.editedReaction.startDate = `${value}T00:00:00.000Z`;
      },
    },

    formattedEndDate: {
      get(){
        return this.formattedDate(this.editedReaction.endDate);
      },
      set(value){
        this.editedReaction.endDate = `${value}T11:59:59.999Z`;
      },
    },
  },

  methods: {
    publish() {
      if (this.invalidForm) { return; }
      this.$emit(this.isEditing ? 'update-reaction' : 'create-reaction');
    },

    setImgFields(response) {
      this.editedReaction.imgPublicId = response.public_id;
      this.editedReaction.imgUrl = response.secure_url;
      this.editedReaction.imgFormat = response.format;
      this.editedReaction.imgWidth = response.width;
      this.editedReaction.imgHeight = response.height;
    },
    setImgUrl(urlToEdit) {
      this.editedReaction.imgUrl = urlToEdit;
    },

    formattedDate(timestamp) {
      return timestamp && timestamp.length > 10 ? timestamp.substring(0, 10) : timestamp;
    },
  },
};
</script>
